import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Catalog from "./Catalog";
function App() {
  return (
    <div className="app">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/catalog" element={<Catalog />} /> */}
          <Route path="/*" element={<Home />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
